import Http from '@/utils/http'
const baseUrl = '/app/teacher'

/**
 *作品列表
 * @param params
 * 
*/

export const worksList = params => Http.get(`${baseUrl}/works`, { params })


/**
 *删除作品
 * @param worksId
 * 
*/

export const delWorks = worksId => Http.delete(`${baseUrl}/works/${worksId}` )

/**
 *打回作品
 * @param worksId
 * 
*/

export const refuseWorks = worksId => Http.put(`${baseUrl}/works/${worksId}/refuse` )

/**
 *评论
 * @param params
 * 
*/

export const giveComment = params => Http.post(`${baseUrl}/works/comment`,  params )

/**
 *删除评论
 * @param commentId
 * 
*/

export const delComment = commentId => Http.delete(`${baseUrl}/works/comment/${commentId}` )

/**
 *评分
 * @param params
 * 
*/

export const giveGrade = params => Http.post(`${baseUrl}/works/${params.worksId}/grade`,  params )
